/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --gap: var(--nve-ref-space-xs);
  --font-size: var(--nve-ref-font-size-100);
  --font-weight: var(--nve-ref-font-weight-semibold);
  --background: var(--status-color);
  --color: var(--nve-sys-text-white-color);
  --border-radius: var(--nve-ref-border-radius-full);
  --height: var(--nve-ref-size-300);
  --width: var(--nve-ref-size-300);
  --padding: 0;
  --border: 0;
  width: auto;
  display: inline-flex;
}

[internal-host] {
  font-weight: var(--font-weight);
  font-size: var(--font-size);
  gap: var(--gap);
  background: var(--background);
  color: var(--color);
  border-radius: var(--border-radius);
  height: var(--height);
  width: var(--width);
  padding: var(--padding);
  border: var(--border);
  display: flex;
  line-height: 1em;
  place-items: center;
  place-content: center;
}

:host([size='sm']) {
  --height: var(--nve-ref-size-200);
  --width: var(--nve-ref-size-200);
  --font-size: var(--nve-ref-font-size-50);
}

:host([size='lg']) {
  --height: var(--nve-ref-size-400);
  --width: var(--nve-ref-size-400);
  --font-size: var(--nve-ref-font-size-200);
}

:host(:state(has-text)) {
  --width: fit-content;
  --height: fit-content;
  --padding: calc(var(--font-size) * 0.1) calc(var(--font-size) * 0.5);
}

::slotted([nve-text]) {
  color: inherit !important;
}

:host([status='warning']) {
  --color: var(--nve-sys-text-black-color);
}
